import { render, staticRenderFns } from "./_topic.vue?vue&type=template&id=9b615d80&scoped=true&"
import script from "./_topic.vue?vue&type=script&lang=js&"
export * from "./_topic.vue?vue&type=script&lang=js&"
import style0 from "./_topic.vue?vue&type=style&index=0&id=9b615d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b615d80",
  null
  
)

export default component.exports